import React from 'react';
import { useSelector } from 'react-redux';
import { useNavigationActions } from '../../../lib/navigation/use-navigation-actions.hook';

import {
  orgSeatsSelector,
  orgSeatsPendingSelector,
  orgSeatsInUseSelector,
  orgSeatsAvailableSelector,
  orgPlanSelector,
} from '../../../redux/app/selectors/organization';
import { NavigationPaneRouteParamsContext } from '../../../lib/navigation';

interface SubscriptionDetailsSeatSectionProps {
  handleClick: (any) => void;
}

export const SubscriptionDetailsSeatSection = ({
  handleClick,
} : SubscriptionDetailsSeatSectionProps) => {
  const { navigate } = useNavigationActions();
  const { subdomain } = React.useContext(NavigationPaneRouteParamsContext);
  const plan = useSelector(orgPlanSelector);
  const seats = useSelector(orgSeatsSelector);
  const seatsPending = useSelector(orgSeatsPendingSelector);
  const seatsInUse = useSelector(orgSeatsInUseSelector);
  const seatsAvailable = useSelector(orgSeatsAvailableSelector);
  const isTrialPlan = plan === 'trial-plan-4';

  const handleRedirectToMembers = () => navigate({
    path: `${window.location.origin}/accounts/${subdomain}/members`,
    params: {},
  });

  return (
    <div className="body mt-10">
      <div className="column-left">
        <p className="fsz-16 bold-900">Seats</p>
      </div>
      <div className="column-mid">
        <p className="fsz-16 mb-5 bold-800">{`${seats} Seats`}</p>
        <p className="fsz-13">
          {`${seatsInUse} in use.`}
          &nbsp;
          {`${seatsPending} pending.`}
          &nbsp;
          {`${seatsAvailable} available.`}
          &nbsp;
          <span
            onClick={handleRedirectToMembers}
            style={{ cursor: 'pointer' }}
            className="fsz-13 link-blue"
          >
            Manage Seats
          </span>
        </p>
      </div>
      <div className="column-right flex justify-end width-100">
        <button
          type="button"
          className="button sand height-fit-content"
          data-checkouttype="addSeats"
          onClick={handleClick}
          disabled={isTrialPlan}
        >
          Add Seats
        </button>
      </div>
    </div>
  );
};
